<template>
  <div class="menu-extra">
    <div class="extra__wrapper">
      <el-dropdown
        ref="dropdownRef"
        position="bottom-end"
        :show-arrow="false"
        size="large"
        @command="handleDropdownCommand"
      >
        <span class="el-dropdown-link">
          <el-icon class="el-icon--right">
            <MoreFilled />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-if="isFolder" command="rename">重命名</el-dropdown-item>
            <el-dropdown-item command="remove">取消收藏</el-dropdown-item>
            <el-dropdown-item v-if="isFolder" command="addChild">新建子文件夹</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, inject, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'

import { APP_HOME_MENU_KEY } from './util'

const { MoreFilled } = ElementPlusIcons

const props = withDefaults(
  defineProps<{
    menu?: any
  }>(),
  {}
)

const emit = defineEmits(['remove'])

const app = useHostAppInstance()

const appHomeMenu = inject(APP_HOME_MENU_KEY)

const dropdownRef = ref<any>()

const currentMenu = computed(() => {
  return props.menu || []
})

const isFolder = computed(() => {
  return currentMenu.value.isFolder === true
})

function handleDropdownCommand(command: string) {
  if (!appHomeMenu) return

  switch (command) {
    case 'rename':
      appHomeMenu.rename(props.menu)
      break
    case 'remove':
      appHomeMenu.remove(props.menu)
      break
    case 'addChild':
      appHomeMenu.addChild(props.menu)
      break
  }
}
</script>

<style lang="scss" scoped></style>
